"use strict";
export var InterfacePageName = /* @__PURE__ */ ((InterfacePageName2) => {
  InterfacePageName2["ABOUT_PAGE"] = "about-page";
  InterfacePageName2["EXPLORE_PAGE"] = "explore-page";
  InterfacePageName2["LANDING_PAGE"] = "landing-page";
  InterfacePageName2["NFT_COLLECTION_PAGE"] = "nft-collection-page";
  InterfacePageName2["NFT_DETAILS_PAGE"] = "nft-details-page";
  InterfacePageName2["NFT_EXPLORE_PAGE"] = "nft-explore-page";
  InterfacePageName2["NFT_PROFILE_PAGE"] = "nft-profile-page";
  InterfacePageName2["NOT_FOUND"] = "not-found";
  InterfacePageName2["POOL_DETAILS_PAGE"] = "pool-details-page";
  InterfacePageName2["POOL_PAGE"] = "pool-page";
  InterfacePageName2["SWAP_PAGE"] = "swap-page";
  InterfacePageName2["TOKENS_PAGE"] = "tokens-page";
  InterfacePageName2["TOKEN_DETAILS_PAGE"] = "token-details";
  InterfacePageName2["VOTE_PAGE"] = "vote-page";
  return InterfacePageName2;
})(InterfacePageName || {});
export var InterfaceSectionName = /* @__PURE__ */ ((InterfaceSectionName2) => {
  InterfaceSectionName2["CURRENCY_INPUT_PANEL"] = "swap-currency-input";
  InterfaceSectionName2["CURRENCY_OUTPUT_PANEL"] = "swap-currency-output";
  InterfaceSectionName2["MINI_PORTFOLIO"] = "mini-portfolio";
  InterfaceSectionName2["NAVBAR_SEARCH"] = "Navbar Search";
  InterfaceSectionName2["WIDGET"] = "widget";
  return InterfaceSectionName2;
})(InterfaceSectionName || {});
export var InterfaceModalName = /* @__PURE__ */ ((InterfaceModalName2) => {
  InterfaceModalName2["ASTRO_CHAIN_LAUNCH_MODAL"] = "astro-chain-launch-modal";
  InterfaceModalName2["CONFIRM_SWAP"] = "confirm-swap-modal";
  InterfaceModalName2["EXTENSION_LAUNCH_PROMOTIONAL_MODAL"] = "extension-launch-promotional-modal";
  InterfaceModalName2["GETTING_STARTED_MODAL"] = "getting-started-modal";
  InterfaceModalName2["NFT_LISTING"] = "nft-listing-modal";
  InterfaceModalName2["NFT_TX_COMPLETE"] = "nft-tx-complete-modal";
  InterfaceModalName2["TOKEN_SELECTOR"] = "token-selector-modal";
  return InterfaceModalName2;
})(InterfaceModalName || {});
export var InterfaceElementName = /* @__PURE__ */ ((InterfaceElementName2) => {
  InterfaceElementName2["ABOUT_PAGE_ANALYTICS_CARD"] = "about-page-analytics-card";
  InterfaceElementName2["ABOUT_PAGE_BUY_CRYPTO_CARD"] = "about-page-buy-crypto-card";
  InterfaceElementName2["ABOUT_PAGE_DEV_DOCS_CARD"] = "about-page-dev-docs-card";
  InterfaceElementName2["ABOUT_PAGE_EARN_CARD"] = "about-page-earn-card";
  InterfaceElementName2["ABOUT_PAGE_NFTS_CARD"] = "about-page-nfts-card";
  InterfaceElementName2["ABOUT_PAGE_SWAP_CARD"] = "about-page-swap-card";
  InterfaceElementName2["ABOUT_PAGE_SWAP_ELEMENT"] = "about-page-swap-element";
  InterfaceElementName2["AUTOROUTER_VISUALIZATION_ROW"] = "expandable-autorouter-visualization-row";
  InterfaceElementName2["BLOG_LINK"] = "blog-link";
  InterfaceElementName2["CAREERS_LINK"] = "careers-link";
  InterfaceElementName2["CLOSE_BUTTON"] = "close-button";
  InterfaceElementName2["COMMON_BASES_CURRENCY_BUTTON"] = "common-bases-currency-button";
  InterfaceElementName2["CONFIRM_SWAP_BUTTON"] = "confirm-swap-or-send";
  InterfaceElementName2["CONNECT_WALLET_BUTTON"] = "connect-wallet-button";
  InterfaceElementName2["CONTINUE_BUTTON"] = "continue-button";
  InterfaceElementName2["DISCONNECT_WALLET_BUTTON"] = "disconnect-wallet-button";
  InterfaceElementName2["DOCS_LINK"] = "docs-link";
  InterfaceElementName2["DOWNLOAD_BUTTON"] = "download-button";
  InterfaceElementName2["EXPLORE_BANNER"] = "explore-banner";
  InterfaceElementName2["EXPLORE_POOLS_TAB"] = "explore-pools-tab";
  InterfaceElementName2["EXPLORE_SEARCH_INPUT"] = "explore_search_input";
  InterfaceElementName2["EXPLORE_TOKENS_TAB"] = "explore-tokens-tab";
  InterfaceElementName2["EXPLORE_TRANSACTIONS_TAB"] = "explore-transactions-tab";
  InterfaceElementName2["EXTENSION_DOWNLOAD_BUTTON"] = "extension-download-button";
  InterfaceElementName2["EXTENSION_DOWNLOAD_CONNECTOR"] = "extension-download-connector";
  InterfaceElementName2["FIAT_ON_RAMP_BUY_BUTTON"] = "fiat-on-ramp-buy-button";
  InterfaceElementName2["FIAT_ON_RAMP_LEARN_MORE_LINK"] = "fiat-on-ramp-learn-more-link";
  InterfaceElementName2["IMPORT_TOKEN_BUTTON"] = "import-token-button";
  InterfaceElementName2["LANDING_PAGE_SWAP_ELEMENT"] = "landing-page-swap-element";
  InterfaceElementName2["LEARN_MORE_LINK"] = "learn-more-link";
  InterfaceElementName2["LEGACY_LANDING_PAGE_LINK"] = "legacy-landing-page-link";
  InterfaceElementName2["MAX_TOKEN_AMOUNT_BUTTON"] = "max-token-amount-button";
  InterfaceElementName2["MINI_PORTFOLIO_ACTIVITY_ROW"] = "mini-portfolio-activity-row";
  InterfaceElementName2["MINI_PORTFOLIO_ACTIVITY_TAB"] = "mini-portfolio-activity-tab";
  InterfaceElementName2["MINI_PORTFOLIO_NFT_ITEM"] = "mini-portfolio-nft-item";
  InterfaceElementName2["MINI_PORTFOLIO_NFT_TAB"] = "mini-portfolio-nft-tab";
  InterfaceElementName2["MINI_PORTFOLIO_POOLS_ROW"] = "mini-portfolio-pools-row";
  InterfaceElementName2["MINI_PORTFOLIO_POOLS_TAB"] = "mini-portfolio-pools-tab";
  InterfaceElementName2["MINI_PORTFOLIO_TOKENS_TAB"] = "mini-portfolio-tokens-tab";
  InterfaceElementName2["MINI_PORTFOLIO_TOKEN_ROW"] = "mini-portfolio-token-row";
  InterfaceElementName2["NAVBAR_SEARCH_INPUT"] = "navbar-search-input";
  InterfaceElementName2["NFT_ACTIVITY_TAB"] = "nft-activity-tab";
  InterfaceElementName2["NFT_BUY_BAG_PAY_BUTTON"] = "nft-buy-bag-pay-button";
  InterfaceElementName2["NFT_FILTER_BUTTON"] = "nft-filter-button";
  InterfaceElementName2["NFT_FILTER_OPTION"] = "nft-filter-option";
  InterfaceElementName2["NFT_TRENDING_ROW"] = "nft-trending-row";
  InterfaceElementName2["POOLS_TABLE_ROW"] = "pools-table-row";
  InterfaceElementName2["PRICE_UPDATE_ACCEPT_BUTTON"] = "price-update-accept-button";
  InterfaceElementName2["SEND_BUTTON"] = "send-button";
  InterfaceElementName2["SEND_FIAT_TOGGLE"] = "send-fiat-toggle";
  InterfaceElementName2["SEND_MAX_BUTTON"] = "send-max-button";
  InterfaceElementName2["SEND_REVIEW_BUTTON"] = "send-review-button";
  InterfaceElementName2["SETTINGS_CURRENCY_OPTION"] = "settings-currency-option";
  InterfaceElementName2["SETTINGS_LANGUAGE_OPTION"] = "settings-language-option";
  InterfaceElementName2["SUPPORT_LINK"] = "support-link";
  InterfaceElementName2["SWAP_BUTTON"] = "swap-button";
  InterfaceElementName2["SWAP_DETAILS_DROPDOWN"] = "swap-details-dropdown";
  InterfaceElementName2["SWAP_TOKENS_REVERSE_ARROW_BUTTON"] = "swap-tokens-reverse-arrow-button";
  InterfaceElementName2["TAX_SERVICE_BANNER_CTA_BUTTON"] = "tax-service-banner-learn-more-button";
  InterfaceElementName2["TAX_SERVICE_COINTRACKER_BUTTON"] = "tax-service-cointracker-link-button";
  InterfaceElementName2["TAX_SERVICE_TOKENTAX_BUTTON"] = "tax-service-tokentax-link-button";
  InterfaceElementName2["TOKENS_TABLE_ROW"] = "tokens-table-row";
  InterfaceElementName2["TOKEN_SELECTOR_ROW"] = "token-selector-row";
  InterfaceElementName2["TWITTER_LINK"] = "twitter-link";
  InterfaceElementName2["UNISWAP_WALLET_BANNER_DOWNLOAD_BUTTON"] = "uniswap-wallet-banner-download-button";
  InterfaceElementName2["UNISWAP_WALLET_CONNECTOR"] = "uniswap-wallet-connector";
  InterfaceElementName2["UNISWAP_WALLET_LANDING_PAGE_DOWNLOAD_BUTTON"] = "uniswap-wallet-landing-page-download-button";
  InterfaceElementName2["UNISWAP_WALLET_MODAL_DOWNLOAD_BUTTON"] = "uniswap-wallet-modal-download-button";
  InterfaceElementName2["UNISWAP_WALLET_NAVBAR_MENU_DOWNLOAD_BUTTON"] = "uniswap-wallet-navbar-menu-download-button";
  InterfaceElementName2["WALLET_TYPE_OPTION"] = "wallet-type-option";
  return InterfaceElementName2;
})(InterfaceElementName || {});
